import { gql } from "@apollo/client";

export const GET_CONSUMER_DASHBOARD_DATA = gql`
  query consumerDashboardData($businessCustomerId: ID!) {
    consumerDashboardData(businessCustomerId: $businessCustomerId)
      {
        invoicesBalance{
          sundryInvoiceAmountDue
          totalAmountDue
          totalInvoicesDue
          unpaidSundryInvoices
        }
        activeBookings
        activeVehicles
      } 
  }`;

